import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import store from './store/store';
import Routes from './routes/Routes';
import './index.css';

const router = {
  future: {
    v7_startTransition: true
  }
};

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <Provider store={store}>
      <BrowserRouter {...router}>
        <Routes />
      </BrowserRouter>
    </Provider>
  </React.StrictMode>
); 